<div [formGroup]="group">
  <input [formControlName]="field.name" [placeholder]="field.placeholder || field.label" [type]="field.inputType"
    class="search_box">
  <ng-container *ngFor="let validation of field.validations;">
    <div *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</div>
  </ng-container>
</div>